<div class="card-wrapper">
  <div class="row flex-item">
    <div class="col-xs-12 col-sm-4 document-title">
      <span class="document-name"><b>{{ title }}</b></span>
      <span class="date">{{ date }}</span>
    </div>
    <div class="visible-xs" style="height: 10px; width: 100%;"></div>
    <div class="col-xs-10 col-sm-6">
      <div class="row">

        <div class="col-xs-4 col-sm-4">
          <app-status-label [title]="statusEnum.INVIATO" [bgColor]="
            status.toLowerCase() === statusEnum.INVIATO ? '#ffbc6e' : '#e9e9e9'
          "></app-status-label>
        </div>
        <div class="col-xs-4 col-sm-4">
          <app-status-label [title]="statusEnum.ELABORATO" [bgColor]="
            status.toLowerCase() === statusEnum.ELABORATO ? '#84e0be' : '#e9e9e9'
          "></app-status-label>
        </div>
        <div class="col-xs-4 col-sm-4">
          <app-status-label [title]="statusEnum.ERRORE" [bgColor]="
            status.toLowerCase() === statusEnum.ERRORE ? '#fd9f9f' : '#e9e9e9'
          "></app-status-label>
        </div>
      </div>


    </div>
    <div class="col-xs-2 col-sm-2 border-space d-flex justify-content-center">
      <div class="row">
        <div class="col-sm-4 glyphicon glyphicon-eye-open" *ngIf="
            status.toLowerCase() === 'errore' ||
            status.toLowerCase() === 'inviato'
          " (click)="onViewItem()" [attr.aria-label]="'Visualizza documento caricato'"
          title="Visualizza documento caricato"></div>
        <div class="col-xs-4 col-sm-4 glyphicon glyphicon-pencil" style="margin:0" *ngIf="status.toLowerCase() === 'elaborato'"
          [routerLink]="['dettaglio', id]" [attr.aria-label]="'Gestisci elaborazione'" title="Gestisci elaborazione">
        </div>
        <div class="col-xs-4 col-sm-4 glyphicon glyphicon-trash" (click)="onRemoveItem()"
          [attr.aria-label]="'Elimina elaborazione'" title="Elimina elaborazione"></div>
      </div>
    </div>
  </div>
</div>